import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { firestore } from '../../../firebase';

function AllQuizzes() {

    const [quizzes, setQuizzes] = useState([]);

    useEffect(() => {
        try {
            const quizRef = firestore.collection("quiz");
            quizRef.onSnapshot(({docs}) => {
                const quizzes = docs.map(doc => {
                    return {id: doc.id, ...doc.data()}
                });
                setQuizzes(quizzes);
            })    
        } catch (error) {
            console.log(error)
        }
    }, [])

    return (
        <div className="row">
            {quizzes?.map((quiz, index) => {
                return (
                    <div key={index} className="col-md-6 col-lg-4">
                        <div className="card">
                            <img 
                                src="https://firebasestorage.googleapis.com/v0/b/backend-footgrail.appspot.com/o/gallery%2F1602938711695_pexels-photo-225502.jpeg?alt=media&token=65658b75-9528-48dd-ac35-2a55c4cb0905"
                                alt="Quiz"
                                className="img-fluid" 
                            />
                            <div className="card-body">
                                <Link to={`/quiz/${quiz.id}`} className="font-weight-bold">{quiz.name}</Link>
                            </div>
                        </div>
                    </div>
                )
            })}
        </div>
    )

}
export default AllQuizzes